import { render, staticRenderFns } from "./LiveDate.vue?vue&type=template&id=c63cc356&scoped=true&"
import script from "./LiveDate.vue?vue&type=script&lang=js&"
export * from "./LiveDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63cc356",
  null
  
)

export default component.exports